'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _reactRouter = require('react-router');

var _reactToastify = require('react-toastify');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _TermsOfServiceLink = require('../common/TermsOfServiceLink');

var _TermsOfServiceLink2 = _interopRequireDefault(_TermsOfServiceLink);

var _constants = require('../../constants');

var _utils = require('../../utils');

var _Navbar = require('./Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _search = require('./search');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var BRAND_NAME = _constants.AppConstants.BRAND_NAME,
    EXTERNAL_ROUTING = _constants.AppConstants.EXTERNAL_ROUTING,
    ROUTING = _constants.AppConstants.ROUTING;
var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;


var TOAST_ANIM_ENTER_DELAY = 500,
    TOAST_ANIM_EXIT_DELAY = 200;

var MainLayout = (_dec = (0, _mobxReact.inject)('OptionsStore', 'SessionStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(MainLayout, _Component);

  function MainLayout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MainLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MainLayout.__proto__ || Object.getPrototypeOf(MainLayout)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'isLoggedIn', _descriptor, _this), _initDefineProp(_this, 'showBrowserWarning', _descriptor2, _this), _this.isManuallyLoggingOut = false, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MainLayout, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isLoggedIn = this.props.SessionStore.isLoggedIn;

      var _props = this.props,
          OptionsStore = _props.OptionsStore,
          SessionStore = _props.SessionStore;
      // case type and state options used in intake, which loads on all pages

      /*
        Code below checks for SessionStore.user instead of SessionStore.isLoggedIn, because the latter returns
        true even when a user is merely authenticated through following a link in a notification email,
        but not actually logged in. In such cases, options shouldn't be fetched.
      */

      SessionStore.user && OptionsStore.prepareOptionStore();
      this.showBrowserWarning = !/Chrome/.test(window.navigator.userAgent) || !/Google Inc/.test(window.navigator.vendor);
    }
  }, {
    key: 'componentWillReact',
    value: function componentWillReact() {
      var SessionStore = this.props.SessionStore,
          location = _reactRouter.browserHistory.getCurrentLocation();


      if (this.isManuallyLoggingOut) {
        return;
      }

      // this will trigger whenever isLoggedIn changes
      // if we just got logged out and we aren't on the logout page (i.e. token expired) then save the current page into 'next' and push us to the logout screen
      // this could also be used to show a login modal that might be less intrusive to a users workflow
      // you could do even more here, like saving the entire state and having a mechanism to restore it after login
      if (this.isLoggedIn && !SessionStore.isLoggedIn && location.pathname !== ROUTING.logout) {
        var next = _reactRouter.browserHistory.createHref(location);

        window.location = ROUTING.logout + '?next=' + encodeURIComponent(next);
      }

      this.isLoggedIn = SessionStore.isLoggedIn;
    }
  }, {
    key: 'onRefreshClick',
    value: function onRefreshClick(e) {
      e.preventDefault();

      window.location.reload();
    }
  }, {
    key: 'onHijackReleaseClick',
    value: function onHijackReleaseClick() {
      var SessionStore = this.props.SessionStore;

      // set this so that our 'will automatically logout' feature doesn't redirect to login screen
      // let window.location handle below

      this.isManuallyLoggingOut = true;

      SessionStore.endImpersonation();

      window.location = EXTERNAL_ROUTING.funderStaffAdmin;
    }
  }, {
    key: 'onBrowserWarningDismissClick',
    value: function onBrowserWarningDismissClick() {
      this.showBrowserWarning = false;
    }
  }, {
    key: 'renderBrowserNotification',
    value: function renderBrowserNotification() {
      if (!this.showBrowserWarning || this.props.SessionStore.isGuest) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'notification notification-error' },
        _react2.default.createElement(
          'div',
          { className: 'notification-info' },
          _react2.default.createElement(
            'strong',
            null,
            'Warning:'
          ),
          ' Your browser is not currently supported. Please use the latest version of',
          ' ',
          _react2.default.createElement(
            'a',
            { href: 'https://www.google.com/chrome/browser/desktop/', target: '_blank', rel: 'noopener noreferrer' },
            'Google Chrome'
          ),
          '.'
        ),
        _react2.default.createElement(
          'div',
          { className: 'notification-actions' },
          _react2.default.createElement(
            _Button2.default,
            { onClick: this.onBrowserWarningDismissClick },
            'Dismiss'
          )
        )
      );
    }
  }, {
    key: 'renderHijackNotification',
    value: function renderHijackNotification() {
      var _props2 = this.props,
          _props2$SessionStore = _props2.SessionStore,
          isSessionHijacked = _props2$SessionStore.isSessionHijacked,
          user = _props2$SessionStore.user,
          _props2$FunderStore = _props2.FunderStore,
          funder = _props2$FunderStore.funder,
          funderStaff = _props2$FunderStore.funderStaff;


      if (!isSessionHijacked) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'notification notification-warning' },
        _react2.default.createElement(
          'div',
          { className: 'notification-info' },
          funderStaff.is_mighty_support ? _react2.default.createElement(
            'div',
            null,
            'Read only view for ',
            _react2.default.createElement(
              'strong',
              null,
              funder.name
            )
          ) : _react2.default.createElement(
            'div',
            null,
            'You are currently working on behalf of ',
            _react2.default.createElement(
              'strong',
              null,
              getNameOrDefault(user)
            ),
            '.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'notification-actions' },
          _react2.default.createElement(
            _Button2.default,
            { onClick: this.onHijackReleaseClick },
            'Release ',
            getNameOrDefault(user)
          )
        )
      );
    }
  }, {
    key: 'renderUpdateNotification',
    value: function renderUpdateNotification() {
      var SessionStore = this.props.SessionStore;


      if (!SessionStore.isNewVersionAvailable) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'update-notification' },
        'There is a new version of ',
        BRAND_NAME,
        ' available.',
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'a',
          { onClick: this.onRefreshClick },
          'Refresh'
        ),
        ' to update to the latest version.'
      );
    }
  }, {
    key: 'renderToastContainer',
    value: function renderToastContainer() {
      var slideInFadeOut = (0, _reactToastify.cssTransition)({
        duration: [TOAST_ANIM_ENTER_DELAY, TOAST_ANIM_EXIT_DELAY],
        enter: 'ToastSlideIn',
        exit: 'ToastFadeOut'
      });

      return _react2.default.createElement(_reactToastify.ToastContainer, {
        closeOnClick: false,
        draggable: false,
        hideProgressBar: true,
        position: 'bottom-center',
        transition: slideInFadeOut
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'main-layout' },
        _react2.default.createElement(_reactHelmet2.default, {
          defaultTitle: BRAND_NAME,
          titleTemplate: '%s | ' + BRAND_NAME
        }),
        _react2.default.createElement(
          'div',
          { className: 'notifications' },
          this.renderHijackNotification(),
          this.renderBrowserNotification()
        ),
        _react2.default.createElement(_Navbar2.default, null),
        _react2.default.createElement(_search.SlidingSearchBar, null),
        _react2.default.createElement(
          'main',
          null,
          this.props.children
        ),
        this.renderUpdateNotification(),
        this.renderToastContainer(),
        _react2.default.createElement(
          'footer',
          null,
          _react2.default.createElement(_TermsOfServiceLink2.default, null)
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return MainLayout;
}(_react.Component), _class3.propTypes = {
  children: _propTypes2.default.node,
  FunderStore: _propTypes2.default.object.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoggedIn', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'showBrowserWarning', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = MainLayout;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(BRAND_NAME, 'BRAND_NAME', '/app/src/components/layout/MainLayout.js');
  reactHotLoader.register(EXTERNAL_ROUTING, 'EXTERNAL_ROUTING', '/app/src/components/layout/MainLayout.js');
  reactHotLoader.register(ROUTING, 'ROUTING', '/app/src/components/layout/MainLayout.js');
  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/layout/MainLayout.js');
  reactHotLoader.register(TOAST_ANIM_ENTER_DELAY, 'TOAST_ANIM_ENTER_DELAY', '/app/src/components/layout/MainLayout.js');
  reactHotLoader.register(TOAST_ANIM_EXIT_DELAY, 'TOAST_ANIM_EXIT_DELAY', '/app/src/components/layout/MainLayout.js');
  reactHotLoader.register(MainLayout, 'MainLayout', '/app/src/components/layout/MainLayout.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/layout/MainLayout.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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